module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g8EGy"))).then(() => parcelRequire('hEqeo'));